import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme, alpha } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";
import { Footer } from "./Components/Footer";

// Tema Verde/Teal com foco em saúde e bem-estar
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#00897B", // Teal
      dark: "#005F56",
      light: "#4DB6AC",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#4CAF50", // Verde
      dark: "#388E3C",
      light: "#81C784",
      contrastText: "#ffffff",
    },
    background: {
      default: "#F0F4F8",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1F2937",
      secondary: "#4B5563",
    },
    divider: alpha("#4B5563", 0.1),
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 20px",
          boxShadow: "none",
          transition: "background-color 0.3s ease, transform 0.2s ease",
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#005F56",
            transform: "translateY(-2px)",
            boxShadow: `0 4px 12px ${alpha("#00897B", 0.2)}`,
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: "#388E3C",
            transform: "translateY(-2px)",
            boxShadow: `0 4px 12px ${alpha("#4CAF50", 0.2)}`,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: `0 4px 16px ${alpha("#6B7280", 0.08)}`,
          transition: "box-shadow 0.3s ease, transform 0.3s ease",
          "&:hover": {
            boxShadow: `0 8px 24px ${alpha("#6B7280", 0.12)}`,
            transform: "translateY(-4px)",
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

export const LandingPages0004 = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CssBaseline />
        <Navbar />
        <HeroSection />
        <FeaturesSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};
